import Vue from 'vue'
const vueBus = new Vue()
export default vueBus
